// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Display-only OWNER line on an alarm tile: "You", "Unassigned", or the stored
// value (an email today) truncated with a tooltip. Behind alarm-owner-enabled.

import React, { useContext } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import { useFlagOn } from '../../../hooks/useFlagOn';

export const sameAccount = (a?: string | null, b?: string | null) =>
  !!a && !!b && a.trim().toLowerCase() === b.trim().toLowerCase();

export function AlarmOwnerLine({ owner, inline = false }: { owner?: string; inline?: boolean }) {
  const enabled = useFlagOn('alarmOwnerEnabled');
  // Read the context directly: tiles also render outside an AuthProvider.
  const myEmail = useContext(AuthContext)?.user?.email;
  if (!enabled) return null;

  const mine = sameAccount(owner, myEmail);
  const text = mine ? 'You' : (owner ?? 'Unassigned');
  if (inline) {
    return (
      <span className="hs-alarm-row-owner" data-testid="alarm-owner-line">
        <span className="hs-alarm-card-owner-label">Owner</span>
        <span className="hs-alarm-row-owner-value" title={owner && !mine ? owner : undefined}>
          {text}
        </span>
      </span>
    );
  }
  return (
    <div className="hs-alarm-card-owner" data-testid="alarm-owner-line">
      <span className="hs-alarm-card-owner-label">Owner</span>
      <span className="hs-alarm-card-owner-value" title={owner && !mine ? owner : undefined}>
        {text}
      </span>
    </div>
  );
}
